import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchIntegrationsByGroup = async (group, productid) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getIntegrationsByGroup&companyid=${user.companyid}&productid=${productid}&group=${encodeURIComponent(group)}`,
  );

  return response.data;
};

const useIntegrationsByGroupQuery = (group, productid) => {
  return useQuery({
    queryKey: ["integrationsByGroup", group, productid],
    queryFn: () => fetchIntegrationsByGroup(group, productid),
    enabled: Boolean(group && productid),
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export default useIntegrationsByGroupQuery;